import React from "react";
import {
  TestimonialContainer,
  TestimonialH1,
  TestimonialWrapper,
} from "./TestimonialsStyle";
import {
  TestimonialObjFive,
  TestimonialObjFour,
  TestimonialObjOne,
  TestimonialObjSix,
  TestimonialObjThree,
  TestimonialObjTwo,
} from "../../components/TestimonialCard/Data";
import TestimonialCard from "../../components/TestimonialCard/TestimonialCard";
import Carousel from "react-elastic-carousel";
const Testimonials = () => {
  const breakPoints = [
    { width: 1, itemsToShow: 1, renderArrows: false },
    { width: 550, itemsToShow: 2, itemsToScroll: 2, pagination: false },
    { width: 850, itemsToShow: 3, itemsToScroll: 3 },
    { width: 1150, itemsToShow: 3, itemsToScroll: 3 },
    { width: 1450, itemsToShow: 3, itemsToScroll: 3 },
    { width: 1750, itemsToShow: 3, itemsToScroll: 3 },
  ];
  return (
    <TestimonialContainer id="testimonials">
      <TestimonialH1>Testimonials</TestimonialH1>
      <TestimonialWrapper>
        <Carousel
          breakPoints={breakPoints}
          easing="cubic-bezier(1,.15,.55,1.54)"
          tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
          transitionMs={700}
        >
          <TestimonialCard {...TestimonialObjOne} />
          <TestimonialCard {...TestimonialObjTwo} />
          <TestimonialCard {...TestimonialObjThree} />
          <TestimonialCard {...TestimonialObjSix} />
          <TestimonialCard {...TestimonialObjFour} />
          <TestimonialCard {...TestimonialObjFive} />
        </Carousel>
      </TestimonialWrapper>
    </TestimonialContainer>
  );
};

export default Testimonials;
